import { PHONE_MASK, PHONE_PLACEHOLDER } from '@/consts';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';

import { limitInput } from '@/utils/handleChangeForm';
import { inject, ref, watch, watchEffect } from 'vue';

import { useNewDataFormErrorsCargoPickUpStore } from '@/stores/formErrors';

import { useFetchAvailablePickUpTime } from '@/newCargoPickUpPage/hooks/useFetchAvailablePickUpTime';
import { useFetchSuitableOffices } from '@/newCargoPickUpPage/hooks/useFetchSuitableOffices';
import { useCitiesRestrictions } from '@/stores/citiesRestrictions';
import { useSenderFormStore } from '@/stores/senderFormStore';
import { getProperDate } from '@/utils/changeDate';
import { computed } from 'vue';
import { AddressAutocompleteSelectOnly, FIOAutocomplete, InnAutocomplete, OrganizationAutocomplete } from '../../../Components';

export default {
  props: {
    isCargoPickup: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    AddressAutocompleteSelectOnly,
    InnAutocomplete,
    OrganizationAutocomplete,
    FIOAutocomplete,
  },

  setup(props) {
    const dataForm = useNewDataFormCargoPickUpStore();
    const dataFormSender = useSenderFormStore();

    const senderPickUp = computed(() => (dataForm.sender.addressCargoPickup.value || '') + ' ' + dataForm.sender.detailsPickup);

    const formErrors = useNewDataFormErrorsCargoPickUpStore();

    const officesToSelect = ref(['Сухово, 14', 'Победа, 34']);

    const checkDisabledAccount = inject('checkDisabledAccount');

    const cityFromRestrictions = inject('cityFromRestrictions');

    const ruleFormRef = inject('ruleFormRef');

    const citiesRestrictions = useCitiesRestrictions();

    const resetCargoInformation = inject('resetCargoInformation');

    const cities = inject('citiesPickup');

    const toggleResetFields = (value, propsToReset) => {
      if (!value) {
        cargoInfoZaborFormRef.value.resetFields(propsToReset);
      }
    };

    const handlePowerOfAttorneyChange = (value) => {
      if (value) {
        cargoInfoZaborForm.value.model.typePowerOfAttorney = 2;
      } else {
        toggleResetFields(value, ['typePowerOfAttorney']);
      }
    };

    const optionsTypePowerOfAttorney = [
      {
        value: 2, //"Customer",
        label: 'От заказчика',
      },
      {
        value: 1, //"Luch",
        label: 'От ТК',
      },
    ];
    const communications = [
      {
        value: 'Email',
        label: 'Email',
      },
      {
        value: 'Viber',
        label: 'Viber',
      },
      {
        value: 'WhatsApp',
        label: 'WhatsApp',
      },
    ];

    const payersProps = inject('payersProps');

    watch(
      () => dataForm.fetchedSuitableOffices.pickUp,
      (newVal) => {
        const currentSelection = dataForm.sender.addressCargoPickup;
        if (currentSelection && dataForm.sender.senderZaborType === 'Сдать на склад') {
          if (newVal.length === 0) {
            resetAddress();
          } else {
            if (newVal.findIndex((el) => el.id === currentSelection.id) === -1) {
              dataForm.sender.addressCargoPickup = '';
            }
          }
        }
      }
    );

    const resetAddress = () => {
      dataForm.sender.addressCargoPickup = '';
      dataForm.sender.detailsPickup = '';
      dataForm.sender.pickUpDate = '';
      dataForm.sender.cargoTimePickup = '';
      dataForm.sender.comment = '';
      dataForm.sender.whoPaysZabor = '';
      dataForm.sender.typeOfPaymentZabor = '';
      dataForm.sender.typeOfPaymentZabor = '';

      dataForm.sender.senderZaborType = 'Забор груза';
    };
    const handleChangeTypeOfPerson = inject('handleChangeTypeOfPerson');

    const handleChangePayerModalForm = (prop, value) => {
      for (let payerProp of Object.keys(payersProps)) {
        if (payerProp !== prop && payersProps[payerProp][0].value === value) {
          cargoInfoZaborForm.value.model.typeOfPaymentZabor = payersProps[payerProp][1].value;
          return;
        }
      }
      cargoInfoZaborForm.value.model.typeOfPaymentZabor = 'Наличные';
    };

    const handleChangeTypeOfPayment = inject('handleChangeTypeOfPayment');

    const cargoInfoZaborFormRef = ref();
    const cargoInfoZaborForm = ref({
      isOpen: false,
      handleClose: () => {
        if (!dataForm.sender.addressCargoPickup && !dataForm.sender.detailsPickup) {
          resetSenderForm();
        }
        cargoInfoZaborFormRef.value.clearValidate();
      },
      submitForm: async (formEl) => {
        if (!formEl) return;
        await formEl.validate((valid) => {
          if (valid) {
            dataForm.sender.addressCargoPickup = cargoInfoZaborForm.value.model.addressCargoPickup;
            dataForm.sender.detailsPickup = cargoInfoZaborForm.value.model.detailsPickup;
            dataForm.sender.cargoTimePickup = cargoInfoZaborForm.value.model.cargoTimePickup;
            dataForm.sender.comment = cargoInfoZaborForm.value.model.comment;
            dataForm.sender.pickUpDate = cargoInfoZaborForm.value.model.pickupDate;

            dataForm.sender.typeOfPaymentZabor = cargoInfoZaborForm.value.model.typeOfPaymentZabor;
            dataForm.sender.whoPaysZabor = cargoInfoZaborForm.value.model.whoPaysZabor;

            dataForm.sender.powerOfAttorney = cargoInfoZaborForm.value.model.powerOfAttorney;
            dataForm.sender.typePowerOfAttorney = cargoInfoZaborForm.value.model.typePowerOfAttorney;

            dataForm.sender.dataForTheDriver = cargoInfoZaborForm.value.model.dataForTheDriver;
            dataForm.sender.sendTo = cargoInfoZaborForm.value.model.sendTo;

            handleChangeTypeOfPayment('cargoPickup', cargoInfoZaborForm.value.model.typeOfPaymentZabor);

            cargoInfoZaborForm.value.isOpen = false;
          }
        });
      },
      model: dataFormSender,
      rules: {
        addressCargoPickup: [
          {
            validator: (rule, value, callback) => {
              if (!value && !cargoInfoZaborForm.value.model.detailsPickup) {
                callback(new Error('Выберите адрес'));
              }
              callback();
            },
            trigger: 'change',
          },
        ],
        detailsPickup: [
          {
            validator: (rule, value, callback) => {
              if (!value && !cargoInfoZaborForm.value.model.addressCargoPickup) {
                callback(new Error('Введите уточнение'));
              }
              callback();
            },
            trigger: 'change',
          },
        ],
        pickupDate: [{ required: true, message: 'Введите дату', trigger: 'blur' }],
        cargoTimePickup: [{ required: true, message: 'Выберите время', trigger: 'change' }],
        whoPaysZabor: [{ required: true, message: 'Выберите плательщика', trigger: 'change' }],
        typeOfPaymentZabor: [{ required: true, message: 'Выберите тип оплаты', trigger: 'change' }],
        typePowerOfAttorney: [
          {
            validator: (rule, value, callback) => {
              if (cargoInfoZaborForm.value.model.powerOfAttorney && value === '') {
                callback(new Error('Выберите доверенность'));
              }
              callback();
            },
            trigger: 'change',
          },
        ],
        sendTo: [
          {
            validator: (rule, value, callback) => {
              if (cargoInfoZaborForm.value.model.dataForTheDriver && value === '') {
                callback(new Error('Пожалуйста выберите способ'));
              }
              callback();
            },
            trigger: 'change',
          },
        ],
      },
    });
    const resetSenderForm = () => {
      cargoInfoZaborFormRef.value?.resetFields();
      cargoInfoZaborForm.value.model.comment = '';
      dataForm.sender.addressCargoPickup = '';
      dataForm.sender.detailsPickup = '';
      dataForm.sender.cargoTimePickup = '';
      dataForm.sender.pickUpDate = '';
      dataForm.sender.comment = '';

      dataForm.sender.powerOfAttorney = false;
      dataForm.sender.typePowerOfAttorney = '';

      dataForm.sender.dataForTheDriver = false;
      dataForm.sender.sendTo = '';

      dataForm.sender.typeOfPaymentZabor = '';
      dataForm.sender.whoPaysZabor = '';
    };

    const onClickAddressZabor = () => {
      cargoInfoZaborForm.value.model.addressCargoPickup = dataForm.sender.addressCargoPickup;
      cargoInfoZaborForm.value.model.detailsPickup = dataForm.sender.detailsPickup;
      cargoInfoZaborForm.value.model.cargoTimePickup = dataForm.sender.cargoTimePickup;
      cargoInfoZaborForm.value.model.comment = dataForm.sender.comment;
      cargoInfoZaborForm.value.model.pickupDate = dataForm.sender.pickUpDate;

      cargoInfoZaborForm.value.model.powerOfAttorney = dataForm.sender.powerOfAttorney;
      cargoInfoZaborForm.value.model.typePowerOfAttorney = dataForm.sender.typePowerOfAttorney;

      cargoInfoZaborForm.value.model.dataForTheDriver = dataForm.sender.dataForTheDriver;
      cargoInfoZaborForm.value.model.sendTo = dataForm.sender.sendTo;

      cargoInfoZaborForm.value.model.whoPaysZabor = dataForm.sender.whoPaysZabor;
      cargoInfoZaborForm.value.model.typeOfPaymentZabor = dataForm.sender.typeOfPaymentZabor;

      cargoInfoZaborForm.value.isOpen = true;
    };

    const datePickerOptions = (date) => {
      const dates = dataForm.getAvailableDates;

      return dates.findIndex((el) => el === getProperDate(date)) === -1;
    };

    const handleDateChange = () => {
      cargoInfoZaborForm.value.model.cargoTimePickup = '';
    };

    const handleSenderZaborType = () => {
      resetSenderForm();
      if (dataForm.sender.senderZaborType === 'Сдать на склад') {
        if (dataForm.fetchedSuitableOffices.pickUp.length === 1) {
          dataForm.sender.addressCargoPickup = dataForm.fetchedSuitableOffices.pickUp[0];
        }
      }
    };

    const disabledZaborType = ref(false);

    watchEffect(() => {
      const senderCredentials = Boolean(dataForm.sender.fioSender || dataForm.sender.name || dataForm.sender.innSender);
      const cityFrom = Boolean(dataForm.sender.cityFrom);
      const selected = dataForm.sender.senderZaborType;
      const validData = cityFrom;
      if (validData && !selected) {
        dataForm.sender.senderZaborType = 'Забор груза';
      }

      disabledZaborType.value = !(validData || selected);
    });

    const desiredTimeArr = ref(['13:00-14:00', '15:00-21:00']);

    const citiesArr = inject('citiesArr', []);
    const options = [
      {
        value: 'Стандарт',
        label: 'Стандарт',
      },
      {
        value: 'Цилиндры',
        label: 'Цилиндры',
      },
      {
        value: 'Шины',
        label: 'Шины',
      },
    ];

    const availableTimeIntervals = ref([]);

    watch(
      () => cargoInfoZaborForm.value.model.pickupDate,
      (newVal) => {
        availableTimeIntervals.value = dataForm.getAvailableTimePeriods(newVal);
      }
    );

    async function hanlerCityFrom(city) {
      // if ((dataForm.sender.cityFrom === "Челябинск" ||
      // dataForm.sender.cityFrom === "Екатеринбург")) {
      //   dataForm.applicationTimeIsOver = '15:00'
      // }
      // else if(dataForm.applicationTimeIsOver === '15:00') {
      //   dataForm.applicationTimeIsOver = '13:00'
      // }

      Promise.allSettled([useFetchSuitableOffices('acceptanceCargo'), useFetchAvailablePickUpTime()]).then(() => {
        resetAddress();
      });

      // #TODO

      // await citiesRestrictions.handleCityRestrictions('cityFrom', city);

      // resetCargoInformation();

      dataForm.updateApplicationTimeIsOver();
    }

    return {
      dataForm,
      officesToSelect,
      senderPickUp,
      availableTimeIntervals,
      checkDisabledAccount,
      cargoInfoZaborForm,
      handleDateChange,
      disabledZaborType,
      handleChangePayerModalForm,
      communications,
      formErrors,
      ruleFormRef,
      handleSenderZaborType,
      cargoInfoZaborFormRef,
      onClickAddressZabor,
      desiredTimeArr,
      handleChangeTypeOfPerson,
      datePickerOptions,
      citiesArr,
      options,
      PHONE_MASK,
      PHONE_PLACEHOLDER,
      limitInput,
      hanlerCityFrom,
      disableIdenticalCity: function (value) {
        if (value && value.id === dataForm.consignee.cityTo?.id) {
          return true;
        }

        return false;
      },
      toggleResetFields,
      optionsTypePowerOfAttorney,
      handlePowerOfAttorneyChange,
      cities,

      checkPhone: function () {
        if (dataForm.consignee.phoneConsignee === dataForm.sender.phoneSender) {
          dataForm.sender.emailSender = dataForm.consignee.emailConsignee;
          if (dataForm.sender.senderType) {
            dataForm.sender.innSender = dataForm.consignee.innConsignee;
            dataForm.sender.name = dataForm.consignee.name;
          } else {
            dataForm.sender.fioSender = dataForm.consignee.fioConsignee;
          }
        }
      },
    };
  },
};
